import React from "react";
import {RouteObject} from "react-router-dom";
import WebsiteSettingsLayout from "../../layout/WebsiteSettingsLayout/WebsiteSettingsLayout";
import LADWebSettings from "../../pages/LADWebSettings/LADWebSettings";

const WebsiteSettingsRoutes : RouteObject[] = [
    {
        path:'website-settings',
        element:<WebsiteSettingsLayout/>,
        children:[
            {
                index:true,
            element:<LADWebSettings/>
            }
        ]
    }
]

export default WebsiteSettingsRoutes;